import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-177" data-mp="2ln2hwezvnnsn">
      <div className="max-w-3xl mx-auto" data-id="element-178" data-mp="2lm0wphp5dkx7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-179" data-mp="26yfsfkgjdfnp">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-180" data-mp="1y043rnz8crxw">
            Does this sound familiar?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-dark-card p-6 rounded-2xl border border-dark-border" data-id="element-181" data-mp="1nzts47sufsku">
            Sunday night. 10 PM. Tomorrow morning you have a yoga class to
            teach. And you are still sitting there, searching online, trying to
            build a sequence that actually flows — that fits your students, that
            feels professional, that does not feel like you put it together in
            twenty minutes.
            <br data-id="element-182" data-mp="1yykelgihfe2a" />
            <br data-id="element-183" data-mp="1u1lmf3idph6q" />
            <span className="text-gold-light font-medium" data-id="element-184" data-mp="1u23r8oj3x3q9">
              Not because you do not know yoga.
            </span>{' '}
            Because no one ever gave you a complete, ready-to-teach library. You
            have been building every single class from scratch. The time you
            should be resting — you are spending planning. And the worst part is
            not the exhaustion. The worst part is walking into the studio
            feeling like you could have been more prepared.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-185" data-mp="1p428k4plf6fb">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-186" data-mp="2vhjdborfbt5c">
            The real cost of not having the right resource:
          </h3>

          <ul className="space-y-4" data-id="element-187" data-mp="1t7hqcf74mw6d">
            {['Nights lost searching for sequences that work, flow, and fit your specific students', 'Classes that feel repetitive — because you keep falling back on what you already know', 'Visible improvisation that quietly chips away at your confidence as a teacher', 'No variety across weeks — and students who slowly lose motivation without knowing why', 'Weekends spent planning instead of resting, recovering, or living your life'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-dark-card p-4 rounded-xl border border-red-900/30" data-id="element-188" data-mp="1je0xpeiq7n4a" data-mpi={i}>
                <span className="text-red-500 mt-1" data-id="element-189" data-mp="e7slessxpk8w">🔴</span>
                <span className="text-gray-300" data-id="element-190" data-mp="e696p6mxfh98">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-dark-border" data-id="element-191" data-mp="a8tkdjabq7mq">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-192" data-mp="58p1jmly10tc">
              Stop giving away your free time. Your dedication is already there.
              What you need now is the right tool.
            </p>
            <p className="text-xl mt-4 text-white" data-id="element-193" data-mp="3rkmcnvv28mne">
              Plan more than 40 weeks of classes today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}